{
  "schemaVersion": 1,
  "id": "oak-board-38",
  "version": "1.0",
  "kind": "board",
  "species": "Oak",
  "material": "Solid oak",
  "nominalDescription": "Solid European oak 38 mm, planed all round, oiled",
  "edgeDescription": "Solid oak, planed, 1 mm arris",
  "thicknessTicks": 380,
  "nominalThicknessTicks": 380,
  "maxWidthTicks": 1800,
  "maxLengthTicks": 25000,
  "grainAxis": "length",
  "finishSpec": "Hard-wax oil, two coats",
  "density": 720,
  "back": {
    "description": "Oak-veneered plywood 6 mm, B/BB",
    "thicknessTicks": 60,
    "nominalThicknessTicks": 60,
    "sheet": {
      "lengthTicks": 24400,
      "widthTicks": 12200
    },
    "grainAxis": "length",
    "allowRotation": false
  },
  "notes": "Self-authored thick board stock for chunky solid frames (FND-23): oak planed to 38 mm, sold in the same widths as the oak-board-20 profile (up to 180 mm); wider parts are edge-glued from strips by the same rule (plan \u00a75). Back and finish as oak-board-20."
}
